import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const PartyList = ({ title, variant, list }) => {
    const dotClass = variant === 'blue' ? styles.partyBlueDot : styles.partyRedDot;

    return (
        <div className={styles.party}>
            <div className={`${styles.partyHead} ${dotClass}`}>{title}</div>
            <div className={styles.partyList}>
                {list.map((item) => (
                    <div
                        className={styles.partyItem}
                        key={`${item.campName}-${item.partyName}`}
                    >
                        <div className={styles.partyItemName}>
                            {item.partyName}
                        </div>
                        <div className={styles.partyItemNum}>
                            {item.ticketCount}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

PartyList.propTypes = {
    title: PropTypes.string,
    variant: PropTypes.oneOf(['red', 'blue']),
    list: PropTypes.array,
};

export default PartyList;
